module.exports = __webpack_public_path__ + "05fbbcd8412283f0ca6d56c2c0b77909.svg";